import { yleConsentSdkHeadless } from '@yleisradio/consent-sdk/headless';
import { logger } from '../../common/logger';
import { refreshSession } from '../../service/login-api';
import { ConsentAction, MutableConsentName } from '../appTypings';
import { getMutableConsentNames } from './utils';
import { loginFetchClient } from '../../service/loginFetchClient';

export async function acceptConsent(
  acceptType: ConsentAction,
  selectedConsents: Partial<Record<MutableConsentName, boolean>>,
  isLoggedIn: boolean
) {
  try {
    const mutableConsentNames = getMutableConsentNames(isLoggedIn);

    switch (acceptType) {
      case ConsentAction.ACCEPT_ALL: {
        mutableConsentNames.forEach(consent =>
          yleConsentSdkHeadless.setConsent(consent, true)
        );
        break;
      }
      case ConsentAction.ACCEPT_NECESSARY: {
        mutableConsentNames.forEach(consent =>
          yleConsentSdkHeadless.setConsent(consent, false)
        );
        break;
      }
      case ConsentAction.ACCEPT_SELECTED: {
        mutableConsentNames.forEach(consent =>
          yleConsentSdkHeadless.setConsent(
            consent,
            selectedConsents?.[consent] ?? false
          )
        );
        break;
      }
    }

    await yleConsentSdkHeadless.accept();

    // call Login API to maybe set yle_rec cookie based on consent
    await refreshSession(loginFetchClient(), '', false);
  } catch (err) {
    logger.error({ err }, `Failed to set consent cookie`);
  }
}
